// extracted by mini-css-extract-plugin
module.exports =  {"highlight":"yubsm7r","price-wrapper":"inLa3hY","priceWrapper":"inLa3hY"};